import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { HrisEmployeeFragmentDoc } from './HrisEmployeeListContainer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisEmployeeSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type HrisEmployeeSidebarQuery = { __typename?: 'Query', HrisEmployee?: { __typename?: 'HrisEmployee', terminationDate?: string | null, manuallyLinked: boolean, rawHrisData?: { [key: string]: any } | null, createdAt: string, updatedAt: string, id: number, firstName: string, lastName: string, phoneNumber?: string | null, remoteHrisId: string, employmentStatus?: string | null, startDate?: string | null, lastModifiedByMergeBackfillRunId?: number | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null, csvUpload?: { __typename?: 'HrisCsvUpload', id: string, csvUrl: string } | null, locationMemberships: Array<{ __typename?: 'HrisEmployeeLocationMembership', id: string, location: { __typename?: 'HrisLocation', id: number, name: string } }>, teamMemberships: Array<{ __typename?: 'HrisEmployeeTeamMembership', id: string, team: { __typename?: 'HrisTeam', id: number, name: string } }>, user?: { __typename?: 'Employee', id: number, name: string } | null } | null };

export type HrisEmployeeRemoteHrisDataQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type HrisEmployeeRemoteHrisDataQuery = { __typename?: 'Query', HrisEmployee?: { __typename?: 'HrisEmployee', id: number, remoteHrisDataPassthrough?: { [key: string]: any } | null } | null };

export type HrisEmployeeEventFragment = { __typename?: 'HrisEmployeeEvent', pghId: number, pghCreatedAt: string, pghLabel: string, id: number, firstName: string, lastName: string, phoneNumber?: string | null, employmentStatus?: string | null, remoteHrisId?: string | null, startDate?: string | null, terminationDate?: string | null, manuallyLinked: boolean, rawHrisData?: { [key: string]: any } | null, pghContext?: { __typename?: 'PghistoryContext', actorId?: string | null, actorName?: string | null, correlationId?: string | null, isHris?: boolean | null, reason?: string | null } | null };

export type HrisEmployeeEventsQueryVariables = Types.Exact<{
  input: Types.HrisEmployeeEventsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisEmployeeEventsQuery = { __typename?: 'Query', HrisEmployeeEvents: { __typename?: 'HrisEmployeeEvents', totalCount: number, objects: Array<{ __typename?: 'HrisEmployeeEvent', pghId: number, pghCreatedAt: string, pghLabel: string, id: number, firstName: string, lastName: string, phoneNumber?: string | null, employmentStatus?: string | null, remoteHrisId?: string | null, startDate?: string | null, terminationDate?: string | null, manuallyLinked: boolean, rawHrisData?: { [key: string]: any } | null, pghContext?: { __typename?: 'PghistoryContext', actorId?: string | null, actorName?: string | null, correlationId?: string | null, isHris?: boolean | null, reason?: string | null } | null }> } };

export const HrisEmployeeEventFragmentDoc = gql`
    fragment HrisEmployeeEvent on HrisEmployeeEvent {
  pghId
  pghCreatedAt
  pghLabel
  id
  firstName
  lastName
  phoneNumber
  employmentStatus
  remoteHrisId
  startDate
  terminationDate
  manuallyLinked
  rawHrisData
  pghContext {
    actorId
    actorName
    correlationId
    isHris
    reason
  }
}
    `;
export const HrisEmployeeSidebarDocument = gql`
    query HrisEmployeeSidebar($id: Int!) {
  HrisEmployee(id: $id) {
    ...HrisEmployee
    terminationDate
    manuallyLinked
    rawHrisData
    hrisIntegration {
      id
      hrisProvider
    }
    createdAt
    updatedAt
    csvUpload {
      id
      csvUrl
    }
  }
}
    ${HrisEmployeeFragmentDoc}`;

/**
 * __useHrisEmployeeSidebarQuery__
 *
 * To run a query within a React component, call `useHrisEmployeeSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeeSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeeSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisEmployeeSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeeSidebarQuery, HrisEmployeeSidebarQueryVariables> & ({ variables: HrisEmployeeSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeeSidebarQuery, HrisEmployeeSidebarQueryVariables>(HrisEmployeeSidebarDocument, options);
      }
export function useHrisEmployeeSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeeSidebarQuery, HrisEmployeeSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeeSidebarQuery, HrisEmployeeSidebarQueryVariables>(HrisEmployeeSidebarDocument, options);
        }
export type HrisEmployeeSidebarQueryHookResult = ReturnType<typeof useHrisEmployeeSidebarQuery>;
export type HrisEmployeeSidebarLazyQueryHookResult = ReturnType<typeof useHrisEmployeeSidebarLazyQuery>;
export type HrisEmployeeSidebarQueryResult = Apollo.QueryResult<HrisEmployeeSidebarQuery, HrisEmployeeSidebarQueryVariables>;
export const HrisEmployeeRemoteHrisDataDocument = gql`
    query HrisEmployeeRemoteHrisData($id: Int!) {
  HrisEmployee(id: $id) {
    id
    remoteHrisDataPassthrough
  }
}
    `;

/**
 * __useHrisEmployeeRemoteHrisDataQuery__
 *
 * To run a query within a React component, call `useHrisEmployeeRemoteHrisDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeeRemoteHrisDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeeRemoteHrisDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisEmployeeRemoteHrisDataQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeeRemoteHrisDataQuery, HrisEmployeeRemoteHrisDataQueryVariables> & ({ variables: HrisEmployeeRemoteHrisDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeeRemoteHrisDataQuery, HrisEmployeeRemoteHrisDataQueryVariables>(HrisEmployeeRemoteHrisDataDocument, options);
      }
export function useHrisEmployeeRemoteHrisDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeeRemoteHrisDataQuery, HrisEmployeeRemoteHrisDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeeRemoteHrisDataQuery, HrisEmployeeRemoteHrisDataQueryVariables>(HrisEmployeeRemoteHrisDataDocument, options);
        }
export type HrisEmployeeRemoteHrisDataQueryHookResult = ReturnType<typeof useHrisEmployeeRemoteHrisDataQuery>;
export type HrisEmployeeRemoteHrisDataLazyQueryHookResult = ReturnType<typeof useHrisEmployeeRemoteHrisDataLazyQuery>;
export type HrisEmployeeRemoteHrisDataQueryResult = Apollo.QueryResult<HrisEmployeeRemoteHrisDataQuery, HrisEmployeeRemoteHrisDataQueryVariables>;
export const HrisEmployeeEventsDocument = gql`
    query HrisEmployeeEvents($input: HrisEmployeeEventsInput!, $pagination: PaginationInput) {
  HrisEmployeeEvents(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...HrisEmployeeEvent
    }
  }
}
    ${HrisEmployeeEventFragmentDoc}`;

/**
 * __useHrisEmployeeEventsQuery__
 *
 * To run a query within a React component, call `useHrisEmployeeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeeEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisEmployeeEventsQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeeEventsQuery, HrisEmployeeEventsQueryVariables> & ({ variables: HrisEmployeeEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeeEventsQuery, HrisEmployeeEventsQueryVariables>(HrisEmployeeEventsDocument, options);
      }
export function useHrisEmployeeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeeEventsQuery, HrisEmployeeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeeEventsQuery, HrisEmployeeEventsQueryVariables>(HrisEmployeeEventsDocument, options);
        }
export type HrisEmployeeEventsQueryHookResult = ReturnType<typeof useHrisEmployeeEventsQuery>;
export type HrisEmployeeEventsLazyQueryHookResult = ReturnType<typeof useHrisEmployeeEventsLazyQuery>;
export type HrisEmployeeEventsQueryResult = Apollo.QueryResult<HrisEmployeeEventsQuery, HrisEmployeeEventsQueryVariables>;